export const maskPhone = (phone: string) => {
  if (phone.length <= 6) return phone;
  return `${phone.slice(0, 3)} *** ** ${phone.slice(-2)}`;
};
